import { createUseStyles } from 'react-jss';
import { visuallyHidden, defaultFonts } from '@wds/utils';

const useStyles = createUseStyles((theme) => {
  const { pane } = theme;
  return {
    wrenchPane: ({ hide, transparent }) => ({
      ...(hide && visuallyHidden),
      ...defaultFonts(theme),
      background: transparent ? 'none' : pane.bgColor,
    }),

    wrenchPaneBody: () => ({
      padding: pane.padding,
    }),
  };
});

export default useStyles;
